import Button from "@common/components/Button";
import LoginModalContext from "@modules/user/LoginModalContext";
import { useTranslation } from "next-i18next";
import { useContext } from "react";

const UnAuthSavedVehiclesMenu = () => {
  const { t } = useTranslation(["common"]);
  const { setShowModal: setShowLoginModal } = useContext(LoginModalContext);

  const handleLoginClicked = () => {
    setShowLoginModal(true);
  };

  return (
    <div>
      <div className="pb-6 py-6 pl-6 pr-1 flex flex-row justify-between">
        <p className="text-text-light-200 body-4 font-semibold tracking-widest">
          {t("common:go_unlimited").toUpperCase()}
        </p>
      </div>
      <div className="flex flex-col">
        <div className="body-3 p-4 bg-primary-light shadow-elevation-00 text-primary-bold">
          <p className="pb-2">{t("common:go_unlimited_description")}</p>
          <Button
            buttonStyle="transparent"
            fill="outline"
            border="thick"
            size="small"
            onClick={handleLoginClicked}
          >
            {t("common:log_in_or_sign_up")}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default UnAuthSavedVehiclesMenu;
